import { DrawerDialog } from '@/common/components/drawer-dialog';
import Spacer from '@/common/components/spacer';
import OurSourcesSection, { OurSourcesSectionProps } from './our-sources-section';
import React from 'react';

export const sourceSections: OurSourcesSectionProps[] = [
  {
    title: 'Monthly loan payment',
    text: "Loan payments are estimated based on a 60-month loan at the vehicle's current market value with an APR based on your estimated credit score.",
    link: 'https://www.bankrate.com/loans/auto-loans/rates/',
    iconVariant: 'BaseLoan',
  },
  {
    title: 'Maintenance',
    text: 'Estimated based on data from AAA, assuming 500 miles driven per month.',
    link: 'https://newsroom.aaa.com/wp-content/uploads/2022/08/2022-YDC-Costs-Break-Out-by-Category.pdf',
    iconVariant: 'Maintenance',
  },
  {
    title: 'Insurance',
    text: 'Based on national averages.',
    link: "https://www.bankrate.com/insurance/car/the-true-cost-of-auto-insurance-in-2022/#:~:text=Nationally%2C%20drivers%20spend%20an%20average,the%20average%20American's%20annual%20income",
    iconVariant: 'Insurance',
  },
];

export interface OurSourcesDrawerDialogProps {
  trigger: React.ReactNode;
}

export default function OurSourcesDrawerDialog({ trigger }: OurSourcesDrawerDialogProps) {
  return (
    <DrawerDialog trigger={trigger} title="Our sources">
      <p className="body">
        Flexcar offers significant savings vs. traditional car ownership by eliminating
        upfront down payments, reducing monthly car and insurance costs, and covering
        annual expenses like maintenance and roadside assistance in the annual membership.
      </p>
      {sourceSections.map((section) => (
        <React.Fragment key={section.title}>
          <Spacer variant="height24" />
          <OurSourcesSection
            title={section.title}
            text={section.text}
            link={section.link}
            iconVariant={section.iconVariant}
          />
        </React.Fragment>
      ))}
      <Spacer variant="height24" />

      <p className="sub text-[12px]">
        Estimates can vary and estimated savings are not guaranteed for all members.
      </p>
    </DrawerDialog>
  );
}
